import React, { Fragment } from "react";
import PropTypes from "prop-types";

import useGet from "../../hooks/useGet";
import { EligibilityProvider } from "../../contexts/EligibilityContext";

import DiseaseFundLoading from "./DiseaseFundLoading";
import DiseaseFundError from "./DiseaseFundError";
import DiseaseFundMaintenance from "./DiseaseFundMaintenance";
import DiseaseFundBanner from "./DiseaseFundBanner";
import DiseaseFundInfo from "./DiseaseFundInfo";
import DiseaseFundMeds from "./DiseaseFundMeds";

const apiUrl = "/wp-json/salesforce/v1/funds";

const DiseaseFundDetail = ({
  title,
  groupId,
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
  jumpLink,
  jumpLinks,
  jumpLinkAnchors,
  eligibilityCriteria,
  medicationsHeading,
  medicationsContent,
  grantType,
  assistanceAmount,
  fundIntroTitle,
  fundIntro,
  additionalAssistanceAmountInformation,
  eligibilityChecklistTitle,
  eligibilityItems,
}) => {
  const [loading, response, error] = useGet(
    `${apiUrl}/${groupId}?criteria=true&medications=true`
  );

  return (
    <Fragment>
      {response && !loading && !maintenance && (
        <EligibilityProvider>
          <DiseaseFundBanner
            title={title}
            data={response.data.funds[0]}
            jumpLink={jumpLink}
            jumpLinkAnchors={jumpLinkAnchors}
            grantType={grantType}
            assistanceAmount={assistanceAmount}
          />

          {!maintenance && (
            <Fragment>
              <DiseaseFundInfo
                title={title}
                data={response.data.funds[0]}
                eligibilityCriteria={eligibilityCriteria}
                jumpLinks={jumpLinks}
                jumpLinkAnchors={jumpLinkAnchors}
                grantType={grantType}
                assistanceAmount={assistanceAmount}
                additionalAssistanceAmountInformation={additionalAssistanceAmountInformation}
                fundIntroTitle={fundIntroTitle}
                fundIntro={fundIntro}
                eligibilityChecklistTitle={eligibilityChecklistTitle}
                eligibilityItems={eligibilityItems}
              />
              <DiseaseFundMeds
                medications={response.data.funds[0].medications}
                groupId={groupId}
                jumpLinkAnchors={jumpLinkAnchors}
                medicationsHeading={medicationsHeading}
                medicationsContent={medicationsContent}
              />
            </Fragment>
          )}
        </EligibilityProvider>
      )}

      {loading && !maintenance && <DiseaseFundLoading title={title} />}

      {error && !maintenance && <DiseaseFundError title={title} />}

      {maintenance && (
        <DiseaseFundMaintenance
          title={title}
          maintenanceMessageLine1={maintenanceMessageLine1}
          maintenanceMessageLine2={maintenanceMessageLine2}
        />
      )}
    </Fragment>
  );
};

DiseaseFundDetail.propTypes = {
  title: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  eligibilityCriteria: PropTypes.string,
  assistanceAmount: PropTypes.string,
  additionalAssistanceAmountInformation: PropTypes.string,
  grantType: PropTypes.string,
  jumpLinks: PropTypes.array,
  jumpLinkAnchors: PropTypes.array,
  eligibilityChecklistTitle: PropTypes.string,
  eligibilityItems: PropTypes.array
};

export default DiseaseFundDetail;
